// extracted by mini-css-extract-plugin
module.exports = {"root":"BmiRanges_root__juCW1","ranges":"BmiRanges_ranges__1IrPG"};